<template>
    <div>
        <h1>Operaattorina Karanteenissa</h1>
        <p>
            Operaattorien tehtäviin pähkinänkuoressa kuuluu:
        </p>
        <ul>
            <li>Hoitaa grief ja hack-client tapaukset</li>
            <li>Rollback / Restore</li>
            <li>Bannia pelaajia tarvittaessa</li>
            <li>Hoitaa Xray tapaukset</li>
            <li>Yleinen vahtiminen (gm3/sv)</li>
            <li>Valvoa moderaattoreita...</li>
        </ul>
        <p>
            Operaattori operoi, mutta ei omista /op.
        </p>
        <p>
            Operaattorina aukeavat ominaisuudet ovat luottamusta vaativia ja joita väärin käyttämällä voi saada paljon
            tuhoa aikaan. Mieti mitä teet, tarvittaessa kysy. Operaattorin käsissä on paljon valtaa.
        </p>
        <h2>
            Täysi lista operaattorina aukeavista komennoista
        </h2>

        <h3>Yleiset</h3>
        <div class="command-list">
            <Command command="" params="" desc="Kaikki Moderaattorina aukeavat" example="" />
            <Command command="bal" params="pelaaja" desc="Vihdoin permi nähdä toisten varallisuus" example="" />
            <Command command="eco" params="give pelaaja" desc="Anna rahaa pelaajalle" example="" />
            <Command command="eco" params="take pelaaja" desc="Poista rahaa pelaajalta" example="" />
            <Command
                command="editwarp"
                params="create, edit, delete, rename"
                desc="Warppien tekoon ja muokkaamiseen"
                example="esim /editwarp create Noobcity2"
            />
            <Command command="gmc, /gms, /gmsp, /gma)" params="" desc="kaikki gamemodet" example="" />
            <Command command="heal" params="" desc="" example="" />

            <Command command="ban" params="pelaaja syy" desc="Perma bän" />
            <Command command="kill" params="pelaaja" desc="Tappaa pelaajan" />
            <Command command="ipban" params="pelaaja aika syy" desc="Ipban pelaaja, ilman aikaa perma" />
            <Command command="ipmute" params="pelaaja aika syy" desc="Ipmute pelaaja, ilman aikaa perma" />
        </div>

        <h3>Aluemuokkaukset</h3>
        <div class="command-list">
            <Command
                command="rg"
                params="addmember alueen_nimi pelaaja"
                desc="Lisää pelaajan alueeseen"
                example="oikeudet tälle on rikki"
            />
            <Command
                command="rg"
                params="removemember alueen_nimi pelaaja"
                desc="Poistaa pelaajan alueesta"
                example="oikeudet tälle on rikki"
            />
            <Command
                command="rg"
                params="addowner alueen_nimi pelaaja"
                desc="Lisää omistajan alueelle"
                example="oikeudet tälle on rikki"
            />
            <Command
                command="rg"
                params="removeowner alueen_nimi pelaaja"
                desc="Poistaa omistajan alueesta"
                example="oikeudet tälle on rikki"
            />
        </div>

        <h3>Grief tapaukset</h3>
        <div class="command-list">
            <Command
                command="co"
                params="rollback"
                desc="Katso ensin /co i kuka rikkonut, mitä milloin ja /co rollback u:pelaaja r:etäisyys t:aika. Rollbackkäystä voi tehdä myös sovelletummin. Ks coreprotect-opas"
                example="esim. /co rollback u:Susse r:30 t:20d"
            />
            <Command
                command="co "
                params="restore"
                desc="Rollbackkäyksen kumoaminen. Käytännössä toimii täysin samalla tavalla kuin rollback"
                example="ks. coreprotect-opas"
            />
        </div>
        <h2>Lista muista oikeuksista</h2>
        <ul class="feature-list">
            <li>Kyky avata kaikkien arkkuja</li>
            <li>yeetos.pong3</li>
            <li>/rtp ilman viivettä</li>
        </ul>
    </div>
</template>

<script>
import Command from '@/components/Command'

export default {
    name: 'operator',
    components: { Command },
    metaInfo: {
        title: 'Operaattorina'
    }
}
</script>

<style scoped></style>
